import { Dayjs } from 'dayjs';

import { PricingProfileType } from 'pricing/enums';

export enum PricingProfileAccessType {
  COMPANY = 'company',
  USER = 'user',
}

export interface IPricingProfile {
  accessType: PricingProfileAccessType;
  agreementId: string;
  corporateUserName: string;
  costDiscountStructureId: number;
  discountStructureId: number;
  endDate: string;
  fixedPriceStructureId: number;
  id: number;
  marginStructureId: number;
  name: string;
  startDate: string;
  type: PricingProfileType;
  vendorCostStructureId: number;
}

export interface IPricingProfileForm {
  agreementId?: string;
  endDate?: Dayjs;
  name: string;
  shareAccess?: boolean;
  startDate?: Dayjs;
}

export interface ICorporatePricingProfile extends IPricingProfile {
  createdAt: string;
  pricingType: string;
  projectPricingProfileApplyToAllCustomers: number;
  projectPricingProfileId: number;
  updatedAt: string;
}
